export enum ESuggestedProductViewId {
  internalPage = 1,
  shoppingCart = 2,
  homepage = 3,
}
export enum ESuggestedProductType {
  I = 'I',
  X = 'X',
  Z = 'Z',
  P = 'P',
}
